import { getUrlParams } from '@bit/gerenciatd.utils.common';
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import { createSondaContext } from '../../utils/contextUtils';

/**
 * Devuelve el dato de los filtros normalizados
 * o null, en caso de que llame al método sin información
 * @param {object} data
 * @returns {(object|null)}
 */
export const normalizeFilters = (data) => {
  const context = createSondaContext('particulares');
  const sonda = new Sonda({
    processName: 'normalizeFilters',
    context,
    origin: 'sagas/normalizers/Filters',
  });

  if (!data) {
    sonda.errorMessage({ info: 'Data no exist' });
    return null;
  }
  const urlParams = getUrlParams();
  const fitltersUrlParams = urlParams.prefilter;
  let arrParams = [];

  if (fitltersUrlParams) {
    if (!Array.isArray(fitltersUrlParams)) {
      arrParams.push(fitltersUrlParams);
    } else {
      arrParams = fitltersUrlParams;
    }
  }

  const result = {};
  result.title = data.title;
  result.mainItems = data.mainItems;
  result.secondaryItems = data.secondaryItems;
  result.selectedFilters = fitltersUrlParams
    ? arrParams.map(eachFilter => eachFilter)
    : [];
  result.orderSelection = [];
  result.order = data.order;
  result.texts = data.texts;
  result.defaultFilters = data.defaultFilters;
  return result;
};
